var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonWhitesearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.69333,0.64) scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.87,20.17l-5.59,-5.59c1.07,-1.23 1.72,-2.83 1.72,-4.58c0,-3.87 -3.13,-7 -7,-7c-3.87,0 -7,3.13 -7,7c0,3.87 3.13,7 7,7c1.75,0 3.35,-0.65 4.58,-1.71l5.59,5.59zM10,16c-3.31,0 -6,-2.69 -6,-6c0,-3.31 2.69,-6 6,-6c3.31,0 6,2.69 6,6c0,3.31 -2.69,6 -6,6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonWhitesearch);
export default __webpack_public_path__ + "static/media/common-whitesearch.719296a39591084f5eb5f85adcbc6869.svg";
export { ForwardRef as ReactComponent };